import Link from 'next/link';

export const formatUrl = (url) => {
  if (!url) return '';

  url = url.trim().toLowerCase();

  if (url.startsWith('/')) return url;

  const partialProtocol = [
    'h',
    'ht',
    'htt',
    'http',
    'http:',
    'http:/',
    'http://',
    'https',
    'https:',
    'https:/',
    'https://',
    'f',
    'ft',
    'ftp',
    'ftp:',
    'ftp:/',
    'ftp://',
    'ftps',
    'ftps:',
    'ftps:/',
    'ftps://',
    'm',
    'ma',
    'mai',
    'mail',
    'mailt',
    'mailto',
    'mailto:',
    't',
    'te',
    'tel',
    'tel:',
  ];

  if (url.startsWith('mailto:') || url.startsWith('tel:')) {
    return url;
  }
  if (partialProtocol.includes(url) || /^(https?|ftps?|ftp):\/\//i.test(url)) {
    return url;
  }
  return `https://${url.replace(/\s+/g, '')}`;
};

export const identifyLinkType = (url) => {
  if (!url || typeof url !== 'string') {
    return 'unknown';
  }

  const value = url.trim().toLowerCase();

  // Mail & Phone
  if (value.startsWith('mailto:')) {
    return 'mailto';
  }

  if (value.startsWith('tel:')) {
    return 'tel';
  }

  // Internal
  if (value.startsWith('/')) {
    return 'internal';
  }

  // Absolute URL
  if (/^(https?|ftps?|ftp):\/\//i.test(value)) {
    return 'external';
  }

  return 'unknown';
};

export const identifyLink = (url) => {
  const type = identifyLinkType(url);

  return {
    type,

    // Primary flags
    isExternal: type === 'external',
    isInternal: type === 'internal',
    isMail: type === 'mailto',
    isTel: type === 'tel',

    // Extra flags (important)
    isAnchor: type === 'anchor',
    isFile: type === 'file',
    isUnsafe: type === 'unsafe',
    isUnknown: type === 'unknown',
  };
};

export function FormatedLink({ href, children, ...props }) {
  const link = identifyLink(href);

  if (link.isInternal) {
    return (
      <Link href={href} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <a
      href={href}
      target={link.isExternal ? '_blank' : undefined}
      rel={link.isExternal ? 'noopener noreferrer' : undefined}
      {...props}
    >
      {children}
    </a>
  );
}
